export const OWN_FORMULA_SOURCE = {
    IMPORTED: 1,
    MATCHING: 2,
    USER_CREATED: 3
};
